import React from 'react'
import { ekincare_full_logo} from '../../assets/images'
import { Spin } from 'antd';
import {LeftPanel, ResetPassword} from '../common/templates/Login';
import {appApi} from '../../services';
import { handleAppError } from '../handlers';
class ResetPasswordPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      window_height: window.innerHeight,
      password:'',
      confirm_password:'',
      show_password:false,
      show_confirm_password:false,
      checks:[],
      request_state:'none',
    }
  }

  enterHandler = (event) => {
    if(event.key === 'Enter') {
      this.handleSubmit();
    }
  }

  componentDidMount(){
    this.updateDimensions();
    window.addEventListener('keypress', this.enterHandler)
    window.addEventListener("resize", this.updateDimensions.bind(this))
  }
  
  componentWillMount () {
    sessionStorage.setItem('defaultSelectedTab', '9')
    window.removeEventListener('keypress', this.enterHandler)
    window.removeEventListener("resize", this.updateDimensions.bind(this))
  }

  updateDimensions() {
    this.setState({window_height: window.innerHeight})
  }

  handleSubmit = async () => {
    const {password, confirm_password, checks} = this.state;
    if(!checks.includes(false) && password === confirm_password) {
      this.setState({isLoading: true});
      const options = {
        data:{confirm:confirm_password, password, token:this.props.match.params.token}
      }
      try {
        await appApi.reset(options);
        this.setState({request_state:'success', isLoading: false});
      } catch(error) {
        handleAppError(error);
        this.setState({isLoading: false})
      }
    } else this.setState({request_state:'criteria-failed'});
  }

  toggleVisiblity = (event) => {
    const name = event.target.name;
    const element = document.getElementById(name === 'password' ? 'input_password':'input_confirm_password');
    const type = element.type === 'password' ? 'text' : 'password';
    element.setAttribute('type', type);
    this.setState((prevState, _) => {
      return { ['show_'+name]: !prevState['show_'+name] };
    });
    event.stopPropagation();
  };

  setfields = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    const password = name === 'password' ? value:this.state.password;

    const checks = [
      password.length >= 8,
      /(?=.*[A-Z])/.test(password),
      /(?=.*[a-z])/.test(password),
      /(?=.*\d)/.test(password),
    ];

    this.setState({[name]:value, checks, request_state:'none'});
  }

  render() {
    let { isLoading} = this.state;
    const {history} = this.props;

    if(isLoading) {
      return (
        <div className="spiner">
          <Spin size="large"/>
        </div>
      )
    }
    
    return (
      <div className='flex min-h-screen'>
        <LeftPanel />
    
        <div className='w-2/5 pt-16 pl-24 bg-white'>
          <img src={ekincare_full_logo} alt='ekincare_logo' />
          <ResetPassword {...this.state} setfields={this.setfields} toggleVisiblity={this.toggleVisiblity} handleSubmit={this.handleSubmit} history={history}/>
        </div>
      </div>
    );    
  }
}

export default ResetPasswordPage;
